export function isOnDanish() {
    return !isOnEnglish();
}

export function isOnEnglish() {
    return location.pathname.startsWith('/english');
}

export function translatedCloseLabel () {
    return isOnDanish() ? 'Luk' : 'Close';
}
